var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleWarningRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0708 30.1074L22.8233 2.38086C22.1987 1.31445 21.1018 0.78125 20.0049 0.78125C18.9081 0.78125 17.8112 1.31445 17.118 2.38086L0.878186 30.1074C-0.301717 32.2326 1.25531 34.9062 3.76053 34.9062H36.2555C38.7508 34.9062 40.3124 32.2402 39.0708 30.1074ZM4.51006 31.25L19.9364 4.80313L35.4983 31.25H4.51006ZM20.0049 24.0213C18.6826 24.0213 17.6101 25.0938 17.6101 26.4161C17.6101 27.7385 18.6849 28.811 20.008 28.811C21.3311 28.811 22.3998 27.7385 22.3998 26.4161C22.3967 25.0953 21.3303 24.0213 20.0049 24.0213ZM18.1768 12.3594V19.6719C18.1768 20.685 18.9995 21.5 20.0049 21.5C21.0104 21.5 21.8331 20.6812 21.8331 19.6719V12.3594C21.8331 11.3539 21.018 10.5312 20.0049 10.5312C18.9919 10.5312 18.1768 11.3539 18.1768 12.3594Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleWarningRegular);
export default __webpack_public_path__ + "static/media/circle-warning-regular.220a7576f29bc02a4f276261cab89211.svg";
export { ForwardRef as ReactComponent };